import React, { PropTypes } from 'react';
import cx from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default class UserItem extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    selectedUsers: ImmutablePropTypes.map.isRequired,
    onSelected: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onSelected = this.onSelected.bind(this);
  }

  onSelected() {
    this.props.onSelected(this.props.user);
  }

  render() {
    const { user, selectedUsers } = this.props;

    const rowClass = cx('', {
      active: selectedUsers.has(user.id),
    });

    return (
      <tr onClick={this.onSelected} className={rowClass}>
        <td>{user.email}</td>
        <td>{user.first_name}</td>
        <td>{user.last_name}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/UserItem.js